import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import SelectProvince from '../select/SelectProvince';
import FieldHoc from './FieldHoc';

const SelectProvinceField = ({
    input,
    meta,
    placeholder,
    className,
    options
}) => {
    return (
        <SelectProvince
            {...input}
            selectedItem={input.value}
            placeholder={placeholder || input.name}
            inputClassName={cx(className, {
                // TODO: supporto touch???
                'is-error': meta.error && meta.touched
            })}
        />
    );
};

SelectProvinceField.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string
};

SelectProvinceField.defaultProps = {
    className: 'form-input'
};

export default FieldHoc(SelectProvinceField);
